/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */

"use client"

import React, { useState, useEffect } from "react"

import Button from "../Button"
import Card from "../cards/Card"
import PageGrid from "../PageGrid"

const FullSessionsPage: React.FC<any> = ({ data }) => {
  const [password, setPassword] = useState("")
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const auth = sessionStorage.getItem("authenticated")
    if (auth === "true") {
      setIsAuthenticated(true)
    }
    setIsLoading(false) // Mark the loading process as complete
  }, [])

  const handlePasswordSubmit = (e) => {
    e.preventDefault()
    if (password === "RS24sessions") {
      setIsAuthenticated(true)
      sessionStorage.setItem("authenticated", "true")
    } else {
      // eslint-disable-next-line no-alert
      alert("Incorrect password")
    }
  }

  // Ternary logic for rendering the component based on isLoading and isAuthenticated
  return (
    <main className="text-white-100">
      <PageGrid className="py-16 sm:py-24 lg:py-28">
        <h1 className="p-4 mb-4 col-span-full headline2 md:headline1 xl:hero">
          Swell 2024 Videos
        </h1>
        <p className="p-4 body3 md:body2 lg:body1 col-span-full lg:col-span-8 xl:col-span-7">
          Relive the magic of Ripple Swell 2024. Dive into expert sessions on
          how blockchain and digital assets are transforming finance. Learn how
          industry leaders are driving institutional adoption and discover
          strategies to integrate enterprise blockchain solutions into your
          business today.
        </p>
      </PageGrid>
      {isLoading ? null : !isAuthenticated ? ( // If loading, return null (you could add a loading spinner here instead)
        // If not authenticated, show the password form
        <PageGrid>
          <div className="col-span-6 p-4">
            <form onSubmit={handlePasswordSubmit}>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Password"
                className="r-field min-w-full"
              />
              <Button type="submit" className="block mt-4" size="lg">
                Submit
              </Button>
            </form>
            <p className="body2 mt-10">
              This content is password protected. Please reach out to the person
              who shared this link with you if you are having trouble accessing
              it.
            </p>
          </div>
        </PageGrid>
      ) : (
        // If authenticated, show the content
        <PageGrid>
          {data.map((card, index) => (
            <Card
              index={index}
              uri={card.link}
              key={card.title}
              mainImage={card.image.url}
              title={card.title}
              cardType={card.type}
              linkClassName="col-span-full md:col-span-2 my-6 hover:mt-4 hover:mb-8 lg:col-span-4"
            />
          ))}
        </PageGrid>
      )}
    </main>
  )
}

export default FullSessionsPage
